import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const customerContextGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.hasCustomerContext()
    ? true
    : router.createUrlTree(['/customers']);
};

export const customerSelectionGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.canSwitchCustomer()
    ? true
    : router.createUrlTree(['/']);
};

export const writeAccessGuard = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isReadOnly()
    ? router.createUrlTree(['/'])
    : true;
};
